<form [formGroup]="orderDetailsFormGroup">
  <div class="step-one-container">
    <div class="main-column">
      <!-- Top level order details -->
      <orders-create-order-details
        #createOrderDetailsComponent
        [business]="business"
        [formGroup]="formGroup"
        [createMode]="true"
      />

      <!--
        TODO: this is a bit of a hack to allow VMF to create orders for new subscriptions in any currency.
        Longer term fix would be to allow all partners to more easily manage their stores and sell in multiple currencies
       -->
      <orders-currency-selector
        *ngIf="newOrderDetails.partnerId === 'VMF'"
        (currencySelected)="currencyOverride = $event"
      />

      <!-- Line items -->
      <orders-line-items
        #salesOrderConfirmation
        [business]="business"
        [orderMarketId]="newOrderDetails.marketId"
        [specifiedLineItems]="selectedLineItems"
        [editable]="true"
        [startEditing]="true"
        [currencyOverride]="currencyOverride"
        [allowRemovingLastLineItem]="true"
        (lineItemsUpdated)="updateAppPrices($event)"
        (lineItemsInitialized)="updateAppPrices($event)"
      />

      <!-- Upload admin attachments -->
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title>
            <div>
              {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.ADMINISTRATOR_ATTACHMENTS' | translate }}
            </div>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <orders-admin-attachments #adminAttachmentsComponent [uploadUrl]="attachmentsUploadUrl" [createMode]="true" />
        </mat-card-content>
      </mat-card>
    </div>

    <div class="right-column">
      <!-- Variable Wholesale Price(s) -->
      <ng-container *ngIf="variablePricesMap$$ | async as products">
        <ng-container *ngIf="variablePackagePricesMap$$ | async as packages">
          <ng-container *ngIf="partnerCurrency$ | async as pCurrency">
            <orders-variable-prices
              *ngIf="products.size > 0 || packages.size > 0"
              #variablePricesComponent
              [variablePricesMap]="products"
              [variablePackagePricesMap]="packages"
              [partnerCurrency]="pCurrency"
              (updateData)="updateMap($event, pCurrency)"
            />
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="orderConfig$ | async as orderConfig">
        <!-- Admin Notes -->
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>
              {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.ADMINISTRATIVE_NOTES_TITLE' | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <orders-notes
              #adminNotes
              [noteType]="'administrator'"
              [existingNotes]="orderConfig.defaultNotesContent ?? ''"
              [createMode]="true"
            />
          </mat-card-content>
        </mat-card>

        <!-- Customer Notes -->
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>
              {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.CUSTOMER_NOTES_TITLE' | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <orders-notes #customerNotes [noteType]="'customer'" [createMode]="true" />
          </mat-card-content>
        </mat-card>

        <!-- Tags -->
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>
              <div>
                {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.TAGS' | translate }}
              </div>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <orders-tags
              *ngIf="orderConfig.salespersonOptions.disableTagging !== true"
              #tagsComponent
              [newOrderDetails]="newOrderDetails"
              [createMode]="true"
            />
          </mat-card-content>
        </mat-card>
      </ng-container>
    </div>
  </div>
</form>
